import { render } from "./TabDetail.vue?vue&type=template&id=c493910e"
import script from "./TabDetail.vue?vue&type=script&lang=js"
export * from "./TabDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__